<template>
  <svg
    class="introBlock__readMoreSvg"
    width="52"
    height="51"
    viewbox="0 0 52 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50.9945 25.1292C50.9945 38.4095 40.0422 49.2038 26.4963 49.2038C12.9504 49.2038 1.99805 38.4095 1.99805 25.1292C1.99805 11.849 12.9504 1.05469 26.4963 1.05469C40.0422 1.05469 50.9945 11.849 50.9945 25.1292Z"
      stroke="#212121"
      stroke-width="2"
    />
    <path
      d="M24.5662 31.0781V18.7912H27.3539V31.0781H24.5662ZM19.8166 26.3285V23.5408H32.1035V26.3285H19.8166Z"
      fill="#212121"
    />
  </svg>
</template>

<script>
export default {
  name: 'ShowMore',
};
</script>
